import React from 'react';

import { Icon, addWithConfig } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { useNavigation } from 'hooks/navigation/use-navigation';
import { useCart } from 'hooks/use-cart';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';
import { routes } from 'utils/routing';

const StyledButton = addWithConfig(ActionButton).withConfig({
  backgroundColor: primitive.bk.$bbqBrown,
  borderColor: primitive.bk.$bbqBrown,
  _text: {
    color: primitive.bk.$mayoEggWhite,
  },
  _hover: {
    _text: {
      color: primitive.bk.$mayoEggWhite,
    },
  },
});

const CartButton = () => {
  const { navigate } = useNavigation();
  const hideCartMenu = useIsMobileBreakpoint();

  const { calculateCartTotal } = useCart();
  const { formatCurrencyForLocale } = useUIContext();

  if (hideCartMenu) {
    return null;
  }

  const handleOnPress = () => {
    navigate(routes.cart);
  };

  return (
    <StyledButton
      variant={ActionButtonVariants.PRIMARY}
      size={ActionButtonSizes.SMALL}
      data-testid="cart-button-desktop"
      onPress={handleOnPress}
      startIcon={<Icon variant="cart" aria-hidden />}
    >
      {formatCurrencyForLocale(calculateCartTotal())}
    </StyledButton>
  );
};
export default CartButton;
